import { useMediaUrl } from '../hooks/hooks_index.js';
import { Loading } from './components_index.js';
import { useState } from 'react';

export function MediaImage({mediaID, alt, className}) {
  const {data: url} = useMediaUrl(mediaID);

  return <img src={url} alt={alt ?? ""} className={className ?? ""}/>;
}

export function MediaIcon({mediaID, alt, className}) {
  const {data: iconUrl, isError: iconError} = useMediaUrl(mediaID, {
    icon: true,
    enabled: mediaID !== "S_logo_PNG.png"
  });

  const {data: fullUrl} = useMediaUrl(mediaID, {
    enabled: mediaID === "S_logo_PNG.png" || iconError
  });

  const url = iconUrl ?? fullUrl;

  return <img src={url} alt={alt ?? ""} className={className ?? ""}/>;
}

export function MediaImageLoading({src, className, containerName}) {
    const [loading, setLoading] = useState(true);
    const {data: url} = useMediaUrl(src);
    return (
      <div className={`${containerName ?? 'default'}-img-container`}>
        {loading && (
          <Loading /> 
        )}
        <img
          src={url}
          className={className}
          onLoad={() => setLoading(false)}
          alt='Image Loading'
        />
      </div>
    )
  }

export function MediaIconLoading({src, className, containerName}) {
  const [loading, setLoading] = useState(true);
  // const {data: iconUrl, isError: iconError} = useMediaUrl(src, {icon: true});
  // const {data: fullUrl} = useMediaUrl(src, {enabled: iconError});
  const {data: iconUrl, isError: iconError} = useMediaUrl(src, {
    icon: true,
    enabled: src !== "S_logo_PNG.png"
  });

  const {data: fullUrl} = useMediaUrl(src, {
    enabled: src === "S_logo_PNG.png" || iconError
  });

  const url = iconUrl ?? fullUrl;

  return (
    <div className={`${containerName ?? 'default'}-img-container`}>
      {loading && (
        <Loading /> 
      )}
      <img
        src={url}
        className={className}
        onLoad={() => setLoading(false)}
        alt='Image Loading'
      />
    </div>
  )
}